import DownloadButtonLogo from '../../assets/download-button.svg?react';
import { useDownload } from '../../hooks/useDownload';
import { capturePageAction } from '../../utils/newrelic';

import './DownloadButton.scss';

export const DownloadButton = ({
  artifactKey,
  buttonText,
  version,
  ariaLabel,
}: {
  artifactKey: string;
  buttonText: string;
  version: string;
  ariaLabel?: string;
}) => {
  const { downloadFile, isDownloading } = useDownload();

  const handleDownload = () => {
    capturePageAction('download_clicked', { artifactKey, version });
    downloadFile(artifactKey, version);
  };

  return (
    <button
      onClick={handleDownload}
      disabled={isDownloading}
      className="download-button"
      type="button"
      aria-label={ariaLabel}
    >
      <p className="download-button-text">{buttonText}</p>
      <DownloadButtonLogo className="download-button-logo" aria-hidden="true" />
    </button>
  );
};
